var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnhed01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f4f4f4;}.cls-2{fill:none;stroke:#e7e7e7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3-2",
    "data-name": "Ellipse 3-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 23.5,
    cy: 23.5,
    r: 23.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 23.5,
    cy: 23.5,
    r: 23
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2211",
    "data-name": "Path 2211",
    className: "cls-3",
    d: "M32.54,15.06l1-1A8.6,8.6,0,0,0,21.36,14l-.12.13,1,1a7.4,7.4,0,0,1,10.31,0Zm-1.1,1a5.63,5.63,0,0,0-8-.13l-.14.13,1,1a4.47,4.47,0,0,1,6.14,0Zm-.37,7.74H28.62V18.87H26.16v4.91H13.87a2.46,2.46,0,0,0-2.45,2.46v4.91a2.45,2.45,0,0,0,2.45,2.45h17.2a2.46,2.46,0,0,0,2.46-2.45V26.24a2.47,2.47,0,0,0-2.46-2.46ZM17.56,29.92H15.1V27.46h2.46Zm4.3,0H19.4V27.46h2.46Zm4.3,0H23.7V27.46h2.45Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnhed01);
export default __webpack_public_path__ + "static/media/enhed_01.4e90818a.svg";
export { ForwardRef as ReactComponent };